import { useEffect, useState } from "react";
import { useSession } from "../session/Context";
import { toast } from "react-toastify";
import API from "../Api";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";

interface KeyCardProps {
  data: any;
  keyID: string;
  updateData: (newData: any) => void;
  deleteData: () => void;
}

export default function KeyCard(props: KeyCardProps) {
  const [show, setShow] = useState(false);
  const { brand } = useSession();

  const removeApi = (id: any, name: any): void => {
    let url = "/api/v1";
    if (brand !== "") {
      url += "/brand/" + brand + "/access-token";
    } else {
      url += "/brand/root/access-token";
    }

    API(url, {
      method: "DELETE",
      body: id,
    })
      .then((resp) => {
        toast.success("Successfully removed API key " + name, {
          theme: "colored",
        });
        props.deleteData();
      })
      .catch((e) => {
        toast.error("Error " + e, { theme: "colored" });
        console.error(e);
      });
  };

  const onEnableDisable = (id: any, el: any): void => {
    let url = "/api/v1";
    if (brand !== "") {
      url += "/brand/" + brand + "/access-token";
    } else {
      url += "/brand/root/access-token";
    }

    API(url, {
      method: "POST",
      body: JSON.stringify({
        type: el ? "disallow" : "allow",
        token: id,
      }),
    })
      .then((resp) => {
        toast.success("Updated API key ", { theme: "colored" });
        //console.log(resp);

        // update data
        props.data.allow = !props.data.allow;
        props.updateData(props.data);
      })
      .catch((e) => {
        toast.error("Error " + e, { theme: "colored" });
        console.error(e);
      });
  };

  return (
    <>
      <div
        className=" fun-fact-card container_credential"
        id={"card:" + props.keyID}
        key={"credential_" + props.keyID}
      >
        <div className="first_box">
          <div
            className="timeline timeline-second-style clearfix" /*onClick={() => credentialDetails(item["id"])}*/
          >
            <div className="timeline-item clearfix">
              <div className="left-part">
                <h5 className="item-period">Key</h5>
              </div>

              <div className="right-part">
                <span style={{ wordBreak: "break-all" }}>{props.keyID}</span>
                {/* <h4 className="item-title">{props.keyID}</h4> */}
              </div>

              <div className="elementUnpublish2">
                <button
                  disabled
                  className="btn btn-primary"
                  onClick={() => onEnableDisable(props.keyID, props.data.allow)}
                >
                  {props.data.allow ? "Disable" : "Allow"}
                </button>
                <button
                  disabled
                  className="btn btn-primary"
                  onClick={() => removeApi(props.keyID, props.data.name)}
                >
                  Remove
                </button>
              </div>
            </div>

            <div className="timeline-item clearfix">
              <div className="left-part">
                <h5 className="item-period">Algorithm</h5>
              </div>

              <div className="right-part">
                <span style={{ wordBreak: "break-all" }}>{props.data.alg}</span>
              </div>

              <div className="elementUnpublish2"></div>
            </div>
            <div className="timeline-item clearfix">
              <div className="left-part">
                <h5 className="item-period">Creation</h5>
              </div>

              <div className="right-part">
                <span style={{ wordBreak: "break-all" }}>
                  {props.data.creation_ts}
                </span>
              </div>
              <div className="elementUnpublish2"></div>
            </div>
            <div className="timeline-item clearfix">
              <div className="left-part">
                <h5 className="item-period">Default</h5>
              </div>

              <div className="right-part">
                <span style={{ wordBreak: "break-all" }}>
                  {JSON.stringify(props.data.is_default)}
                </span>
              </div>
              <div className="elementUnpublish2"></div>
            </div>
            <div className="timeline-item clearfix">
              <div className="left-part">
                <h5 className="item-period">Type</h5>
              </div>

              <div className="right-part">
                <span style={{ wordBreak: "break-all" }}>
                  {props.data.type}
                </span>
              </div>
              <div className="elementUnpublish2"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
